import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface TechCardProps {
  children: ReactNode;
  glow?: boolean;
  hover?: boolean;
  className?: string;
}

export function TechCard({
  children,
  glow = false,
  hover = true,
  className = '',
}: TechCardProps) {
  return (
    <motion.div
      className={`glass-morphism rounded-lg p-6 ${hover ? 'cursor-pointer' : ''} ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      {...(hover && {
        whileHover: {
          y: -5,
          boxShadow: glow 
            ? '0 0 30px rgba(88, 166, 255, 0.6)' 
            : '0 10px 30px rgba(0, 0, 0, 0.3)',
        },
      })}
    >
      {children}
    </motion.div>
  );
}
